import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const fwWingstopFlashSalesAndTicketCompReport: IConfigsType = {
  'fw_wingstop-sales-and-ticket-comp-defad0e1': {
    '/:brand/sales_and_ticket_comp': {
      variables: ['corporateGroup'],
      groupFilter: {
        api: 'fwWingstopCorporateFilter',
        defaultValue: ['Market', 'Market Breakdown'],
      },
      dateFilter: {
        types: ['yesterday', 'custom'],
        defaultType: 'yesterday',
        isDailyCustom: true,
      },
      reportTitle: {
        type: 'title',
        title: 'Sales and Ticket Comp Report',
      },
      downloadSalesReport: {
        type: 'download-csv',
        api: 'fwWingstopSalesAndCompTickets',
        fileName: 'getexpo-far-west-sales-and-ticket-comp-report',
        fileNameFn: (date: string) =>
          `getexpo-far-west-sales-and-ticket-comp-report-${date}`,
        message: 'Download as CSV',
        fields: [
          'groupInfo',
          {
            key: 'ro',
            title: 'RO',
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'market',
            title: 'Market',
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'openedAt',
            title: 'Open Day',
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'netSales',
            title: 'Sales',
          },
          {
            key: 'netSalesSameDayLastYear',
            title: 'Sales same day Last Year',
          },
          {
            key: 'netSalesSameDay2YearsAgo',
            title: 'Sales same day Last 2 Years',
          },
          {
            key: 'wtdNetSales',
            title: 'Sales WTD',
          },
          {
            key: 'wtdNetSales7DaysAgo',
            title: 'Sales WTD Prior Week',
          },
          {
            key: 'wtdNetSalesPercentageDiffToLastYear',
            title: 'Sales WTD Last Year',
          },
          {
            key: 'averageNetSalesTrailing7Days',
            title: 'Sales Avg T7',
          },
          {
            key: 'averageNetSalesTrailing7DaysLastYear',
            title: 'Sales Avg T7 Last Year',
          },
          {
            key: 'netSales7DaysAgo',
            title: 'Sales Prior Week',
          },
          {
            key: 'ptdNetSales',
            title: 'Sales PTD',
          },
          {
            key: 'qtdNetSales',
            title: 'Sales QTD',
          },
          {
            key: 'ytdNetSales',
            title: 'Sales YTD',
          },
          {
            key: 'ttmNetSales',
            title: 'Sales TTM',
          },
          {
            key: 'netSalesPercentageDiffToLastYear',
            title: 'Comp Sales Daily (1-yr SSS)',
          },
          {
            key: 'netSalesPercentageDiffTo7DaysAgo',
            title: 'Comp Sales WoW (1-yr WoW SSS)',
          },
          {
            key: 't7NetSalesPercentageDiffToLastYear',
            title: 'Comp Sales T7 (1-yr T7 SSS)',
          },
          {
            key: 'pwkNetSalesPercentageDiffToLastYear',
            title: 'Comp Sales P-Wk (1-yr P-Wk SSS)',
          },
          {
            key: 'wtdNetSalesPercentageDiffToLastYear',
            title: 'Comp Sales WTD (1-yr WTD SSS)',
          },
          {
            key: 'ptdNetSalesPercentageDiffToLastYear',
            title: 'Comp Sales PTD (1-yr PTD SSS)',
          },
          {
            key: 't30NetSalesPercentageDiffToLastYear',
            title: 'Comp Sales T30 (1-yr T30 SSS)',
          },
          {
            key: 'qtdNetSalesPercentageDiffToLastYear',
            title: 'Comp Sales QTD (1-yr QTD SSS)',
          },
          {
            key: 'ytdNetSalesPercentageDiffToLastYear',
            title: 'Comp Sales YTD (1-yr YTD SSS)',
          },
          {
            key: 'netSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales Daily (2-yr SSS)',
          },
          {
            key: 'wtdNetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales WTD (2-yr WTD SSS)',
          },
          {
            key: 't7NetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales T7 (2-yr T7 SSS)',
          },
          {
            key: 'pwkNetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales P-Wk (2-yr P-Wk SSS)',
          },
          {
            key: 'ptdNetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales PTD (2-yr PTD SSS)',
          },
          {
            key: 'qtdNetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales QTD (2-yr QTD SSS)',
          },
          {
            key: 'ytdNetSalesPercentageDiffTo2YearsAgo',
            title: 'Comp Sales YTD (2-yr YTD SSS)',
          },
          {
            key: 'checkCount',
            title: 'Tickets',
          },
          {
            key: 'checkCount7DaysAgo',
            title: 'Tickets Prior Week',
          },
          {
            key: 'wtdCheckCount',
            title: 'Tickets WTD',
          },
          {
            key: 'ptdCheckCount',
            title: 'Tickets PTD',
          },
          {
            key: 'qtdCheckCount',
            title: 'Tickets QTD',
          },
          {
            key: 'checkCountSameDayLastYear',
            title: 'Tickets Prior Year',
          },
          {
            key: 'checkCountSameDay2YearsAgo',
            title: 'Tickets Prior 2 Years',
          },
          {
            key: 'checkCountPercentageDiffToLastYear',
            title: 'Comp Tickets Daily (1-yr SST)',
          },
          {
            key: 'checkCountPercentageDiffTo7DaysAgo',
            title: 'Comp Tickets WoW (1-yr WoW SST)',
          },
          {
            key: 't7CheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets T7 (1-yr T7 SST)',
          },
          {
            key: 'pwkCheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets P-Wk (1-yr P-Wk SST)',
          },
          {
            key: 'wtdCheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets WTD (1-yr WTD SST)',
          },
          {
            key: 'ptdCheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets PTD (1-yr PTD SST)',
          },
          {
            key: 't30CheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets T30 (1-yr T30 SST)',
          },
          {
            key: 'qtdCheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets QTD (1-yr QTD SST)',
          },
          {
            key: 'ytdCheckCountPercentageDiffToLastYear',
            title: 'Comp Tickets YTD (1-yr YTD SST)',
          },
          {
            key: 'checkCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets Daily (2-yr SST)',
          },
          {
            key: 'wtdCheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets WTD (2-yr WTD SST)',
          },
          {
            key: 't7CheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets T7 (2-yr T7 SST)',
          },
          {
            key: 'pwkCheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets P-Wk (2-yr P-Wk SST)',
          },
          {
            key: 'ptdCheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets PTD (2-yr PTD SST)',
          },
          {
            key: 'qtdCheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets QTD (2-yr QTD SST)',
          },
          {
            key: 'ytdCheckCountPercentageDiffTo2YearsAgo',
            title: 'Comp Tickets YTD (2-yr YTD SST)',
          },
          {
            key: 'checkAverage',
            title: 'Checks',
          },
          {
            key: 'pwkCheckAverage',
            title: 'Checks Prior Week',
          },
          {
            key: 'ptdCheckAverage',
            title: 'Checks PTD',
          },
          {
            key: 'qtdCheckAverage',
            title: 'Checks QTD',
          },
          {
            key: 'checkAverageSameDayLastYear',
            title: 'Checks Prior Year',
          },
          {
            key: 'checkAverageSameDay2YearsAgo',
            title: 'Checks Prior 2 Years',
          },
          {
            key: 'checkAveragePercentageDiffToLastYear',
            title: 'Comp Checks Daily (1-yr SSC)',
          },
          {
            key: 'checkAveragePercentageDiffTo7DaysAgo',
            title: 'Comp Checks WoW (1-yr WoW SSC)',
          },
          {
            key: 't7CheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks T7 (1-yr T7 SSC)',
          },
          {
            key: 'pwkCheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks P-Wk (1-yr P-Wk SSC)',
          },
          {
            key: 'wtdCheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks WTD (1-yr WTD SSC)',
          },
          {
            key: 'ptdCheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks PTD (1-yr PTD SSC)',
          },
          {
            key: 't30CheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks T30 (1-yr T30 SSC)',
          },
          {
            key: 'qtdCheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks QTD (1-yr QTD SSC)',
          },
          {
            key: 'ytdCheckAveragePercentageDiffToLastYear',
            title: 'Comp Checks YTD (1-yr YTD SSC)',
          },
          {
            key: 'checkAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks Daily (2-yr SSC)',
          },
          {
            key: 'wtdCheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks WTD (2-yr WTD SSC)',
          },
          {
            key: 't7CheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks T7 (2-yr T7 SSC)',
          },
          {
            key: 'pwkCheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks P-Wk (2-yr P-Wk SSC)',
          },
          {
            key: 'ptdCheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks PTD (2-yr PTD SSC)',
          },
          {
            key: 'qtdCheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks QTD (2-yr QTD SSC)',
          },
          {
            key: 'ytdCheckAveragePercentageDiffTo2YearsAgo',
            title: 'Comp Checks YTD (2-yr YTD SSC)',
          },
        ],
      },
      salesReportTableSales: {
        type: 'table-v2',
        api: 'fwWingstopSalesAndCompTickets',
        pagination: {
          pageSize: 30,
        },
        row: {
          pinning: {
            top: ['summary'],
          },
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'ro',
            title: 'RO',
            width: '150px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'market',
            title: 'Market',
            background: COLORS.Porcelain,
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2 %>',
          },
          {
            key: 'openedAt',
            title: 'Open Day',
            width: '100px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'sales',
            title: 'Sales',
            align: 'center',
            background: COLORS.Porcelain,
            children: [
              {
                key: 'netSales',
                title: 'Sales',
                sortable: true,
              },
              {
                key: 'netSalesSameDayLastYear',
                title: 'Sales same day Last Year',
                sortable: true,
              },
              {
                key: 'averageNetSalesTrailing7Days',
                title: 'Sales Avg T7',
                sortable: true,
              },
              {
                key: 'averageNetSalesTrailing7DaysLastYear',
                title: 'Sales Avg T7 Last Year',
                sortable: true,
              },
              {
                key: 'wtdNetSales',
                title: 'Sales WTD ',
                sortable: true,
              },
              {
                key: 'pwkNetSales',
                title: 'Sales WTD Prior Week',
                sortable: true,
              },
              {
                key: 'ttmNetSales',
                title: 'Sales TTM',
                sortable: true,
              },
              {
                key: 'netSalesPercentageDiffTo7DaysAgo',
                title: 'WoW',
                sortable: true,
              },
            ],
          },
          {
            key: 'compSales',
            title: 'Comp Sales',
            align: 'center',
            children: [
              {
                key: 'netSalesPercentageDiffToLastYear',
                title: 'Daily (1-yr)',
                sortable: true,
              },
              {
                key: 't7NetSalesPercentageDiffToLastYear',
                title: 'T7',
                sortable: true,
              },
              {
                key: 'pwkNetSalesPercentageDiffToLastYear',
                title: 'P-Wk',
                sortable: true,
              },
              {
                key: 'wtdNetSalesPercentageDiffToLastYear',
                title: 'WTD',
                sortable: true,
              },
              {
                key: 'ptdNetSalesPercentageDiffToLastYear',
                title: 'PTD',
                sortable: true,
              },
              {
                key: 'qtdNetSalesPercentageDiffToLastYear',
                title: 'QTD',
                sortable: true,
              },
              {
                key: 'ytdNetSalesPercentageDiffToLastYear',
                title: 'YTD',
                sortable: true,
              },
            ],
          },
        ],
      },
      salesReportTableTickets: {
        type: 'table-v2',
        api: 'fwWingstopSalesAndCompTickets',
        pagination: {
          pageSize: 30,
        },
        row: {
          pinning: {
            top: ['summary'],
          },
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'ro',
            title: 'RO',
            width: '150px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'market',
            title: 'Market',
            background: COLORS.Porcelain,
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2 %>',
          },
          {
            key: 'openedAt',
            title: 'Open Day',
            width: '100px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'tickets',
            title: 'Tickets',
            align: 'center',
            background: COLORS.Porcelain,
            children: [
              {
                key: 'checkCount',
                title: 'Tickets',
                sortable: true,
              },
              {
                key: 'checkCount7DaysAgo',
                title: 'Tickets Prior Week',
                width: '80px',
                sortable: true,
                align: 'center',
              },
              {
                key: 'checkCountSameDayLastYear',
                title: 'Tickets Prior Year',
                width: '80px',
                sortable: true,
                align: 'center',
              },
              {
                key: 'checkCountPercentageDiffTo7DaysAgo',
                title: 'WoW',
                sortable: true,
              },
            ],
          },
          {
            key: 'compTickets',
            title: 'Comp Tickets',
            align: 'center',
            children: [
              {
                key: 'checkCountPercentageDiffToLastYear',
                title: 'Daily (1-yr)',
                sortable: true,
                align: 'center',
              },
              {
                key: 'pwkCheckCountPercentageDiffToLastYear',
                title: 'P-Wk',
                sortable: true,
              },
              {
                key: 'wtdCheckCountPercentageDiffToLastYear',
                title: 'WTD',
                sortable: true,
              },
              {
                key: 'ptdCheckCountPercentageDiffToLastYear',
                title: 'PTD',
                sortable: true,
              },
              {
                key: 'qtdCheckCountPercentageDiffToLastYear',
                title: 'QTD',
                sortable: true,
              },
              {
                key: 'ytdCheckCountPercentageDiffToLastYear',
                title: 'YTD',
                sortable: true,
              },
            ],
          },
        ],
      },
      salesReportTableChecks: {
        type: 'table-v2',
        api: 'fwWingstopSalesAndCompTickets',
        pagination: {
          pageSize: 30,
        },
        row: {
          pinning: {
            top: ['summary'],
          },
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'ro',
            title: 'RO',
            width: '150px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'market',
            title: 'Market',
            background: COLORS.Porcelain,
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2 %>',
          },
          {
            key: 'openedAt',
            title: 'Open Day',
            width: '100px',
            sortable: true,
            hide: '<%- corporateGroup.tableColumns.length < 2  %>',
          },
          {
            key: 'checks',
            title: 'Checks',
            align: 'center',
            background: COLORS.Porcelain,
            children: [
              {
                key: 'checkAverage',
                title: 'Checks',
                decimal: 2,
                sortable: true,
              },
              {
                key: 'pwkCheckAverage',
                title: 'Checks Prior Week',
                width: '80px',
                decimal: 2,
                sortable: true,
                align: 'center',
              },
              {
                key: 'checkAverageSameDayLastYear',
                title: 'Checks Prior Year',
                width: '80px',
                decimal: 2,
                sortable: true,
                align: 'center',
              },
              {
                key: 'checkAveragePercentageDiffTo7DaysAgo',
                title: 'WoW',
                sortable: true,
              },
            ],
          },
          {
            key: 'compChecks',
            title: 'Comp Checks',
            align: 'center',
            children: [
              {
                key: 'checkAveragePercentageDiffToLastYear',
                title: 'Daily (1-yr)',
                sortable: true,
                align: 'center',
              },
              {
                key: 'pwkCheckAveragePercentageDiffToLastYear',
                title: 'P-Wk',
                sortable: true,
              },
              {
                key: 'wtdCheckAveragePercentageDiffToLastYear',
                title: 'WTD',
                sortable: true,
              },
              {
                key: 'ptdCheckAveragePercentageDiffToLastYear',
                title: 'PTD',
                sortable: true,
              },
              {
                key: 'qtdCheckAveragePercentageDiffToLastYear',
                title: 'QTD',
                sortable: true,
              },
              {
                key: 'ytdCheckAveragePercentageDiffToLastYear',
                title: 'YTD',
                sortable: true,
              },
            ],
          },
        ],
      },
    },
  },
}

export default fwWingstopFlashSalesAndTicketCompReport
